import routes from './configuration.routes';

export const configurationModule = {
    routes
};